import CONFIG from '@whistle/config';
import { CookiesStore, ICookiesService } from '../cookies';
import { MessagesListDTO, SendMessageData, MarkAsReadResponse } from '@/models';
import { transformMessage } from './transform';

export class MessagesService<CookiesService extends ICookiesService> {
  constructor(private cookiesStore: CookiesStore<CookiesService>) {}

  async sendMessage(company: string, message: SendMessageData) {
    const guestId = this.cookiesStore.getGuest();
    const accessToken = this.cookiesStore.getAccessToken();

    if (!guestId || !accessToken) {
      return;
    }

    const response = await fetch(
      `${CONFIG.GUESTAPP_ENDPOINT}/messages/inbound?` +
        new URLSearchParams({
          company,
        }).toString(),
      {
        method: 'POST',
        headers: {
          Authorization: accessToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(message),
      },
    );

    const jsonResponse = await response.json();

    return jsonResponse.results || [];
  }

  async listMessages(
    company: string,
    lastEvaluatedDatetime?: string,
  ): Promise<MessagesListDTO> {
    const guestId = this.cookiesStore.getGuest();
    const accessToken = this.cookiesStore.getAccessToken();

    if (!guestId || !accessToken) {
      return { messages: [] };
    }

    const response = await fetch(
      `${CONFIG.GUEST_ENDPOINT}/${guestId}/messages?` +
        new URLSearchParams({
          company,
          channelType: 'whistle',
          messageType: 'chat',
          lastEvaluatedDatetime: lastEvaluatedDatetime || '',
          useIntegrationId: 'true',
        }).toString(),
      {
        headers: {
          Authorization: accessToken,
        },
        cache: 'no-store',
      },
    );

    const jsonResponse = await response.json();

    const res = jsonResponse.results || { messages: [] };
    res.messages = res.messages.map(transformMessage);
    return res;
  }

  async markAllAsRead(company: string): Promise<MarkAsReadResponse> {
    const guestId = this.cookiesStore.getGuest();
    const accessToken = this.cookiesStore.getAccessToken();

    if (!guestId || !accessToken) {
      return { success: false };
    }

    const response = await fetch(
      `${CONFIG.GUEST_ENDPOINT}/${guestId}/messages/read?` +
        new URLSearchParams({
          company,
          channelType: 'whistle',
        }).toString(),
      {
        method: 'GET',
        headers: {
          Authorization: accessToken,
        },
        cache: 'no-store',
      },
    );

    const jsonResponse = await response.json();

    return jsonResponse.results || { success: false };
  }
}
